import {Component, Input, OnInit} from '@angular/core';
import {Astrowerte, Astrowetter} from '../../../../../model/messwerte/astrowetter';
import {MatTableDataSource} from '@angular/material/table';
import {MesswertPaket} from '../../../../../model/messwerte/messwert-paket';

@Component({
  selector: 'app-astrowetter',
  templateUrl: './astrowetter.component.html',
  styleUrls: ['./astrowetter.component.css', '../rbb-sonstiges-wetter.component.css']
})
export class AstrowetterComponent implements OnInit {

  @Input()
  astrowetter: Astrowetter;


  dataSource = new MatTableDataSource<Astrowerte>();
  displayedColumns = ['datum', 'daemmerung', 'meridian', 'mondaufgang', 'monduntergang', 'sonnenaufgang', 'sonnenuntergang'];


  constructor() {
  }

  ngOnInit(): void {
    this.dataSource.data = this.astrowetter.werte;
  }

}
